import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

let locale = localStorage.getItem("i18n");

const i18n = new VueI18n({
  locale: locale || "id_ID",
  messages: {
    zh_CN: require("./zh-CN.json"),
    id_ID: require("./id-ID.json"),
  },
});

export default i18n;
